module.exports = __webpack_public_path__ + "static/media/ChrisWare.c7c8e6b5.jpg";